import { Checkbox, Row, Space } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import KSearch from 'app/components/Modules/KSearch'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { useState } from 'react'
import * as React from 'react'

type Props = {
  onSelect: (items: number[]) => void
  selectedItems?: ILineItem[]
}
const Drawer: React.FC<CollectionProps<ILineItem, Props>> = ({
  collection: lineItems,
  props: { onSelect, selectedItems }
}) => {
  const [searchText, setSearchText] = useState<string>('')
  const { tCore } = useTranslation({ scope: 'drawer', recordType: RecordType.line_item })

  const label = (item: ILineItem): React.ReactNode => {
    return (
      <Space direction="vertical" size={0}>
        <span className="text-muted">{item.name}</span>
        <span className="text-muted">{item.category_segment_name}</span>
      </Space>
    )
  }

  return (
    <Row gutter={[0, 24]}>
      <KCol span={24}>
        <KSearch
          onChange={(e) => setSearchText(e.target.value)}
          recordType={RecordType.line_item}
          enterButton
        />
      </KCol>
      <KCol span={24}>
        <span>
          <b>{tCore({ id: 'all_machines' })}</b>
        </span>
      </KCol>
      <KCol span={24}>
        <Checkbox.Group
          value={selectedItems.map((item) => item.id)}
          onChange={onSelect}
          options={lineItems
            .filter((item) =>
              item.name.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())
            )
            .map((item) => ({
              ...item,
              id: String(item.id),
              name: item.name,
              label: label(item),
              value: item.id,
              style: { display: 'flex', alignItems: 'start', marginBottom: 8 }
            }))}
        />
      </KCol>
    </Row>
  )
}

export default Drawer
